import type { ReactNode } from "react";
import clsx from "clsx";

type EmptyStateProps = {
  /** Newsreader headline. Wrap at most one word in <em> for warmth. */
  title: ReactNode;
  /** One warm sentence. */
  body?: ReactNode;
  /** A single primary action. */
  action?: ReactNode;
  /** `compact` for inside a card body; `teal` for the full-teal variant. */
  variant?: "default" | "compact" | "teal";
  className?: string;
};

/** Empty and zero states: headline + sparkle + one sentence + one action. */
const EmptyState = ({ title, body, action, variant = "default", className }: EmptyStateProps) => (
  <div
    className={clsx(
      "pz-empty",
      variant === "compact" && "pz-empty--compact",
      variant === "teal" && "pz-empty--teal",
      className,
    )}
    role="status"
  >
    <span className="pz-empty__sparkle" aria-hidden="true">
      ✦
    </span>
    <h3 className="pz-empty__title">{title}</h3>
    {body ? <p className="pz-empty__body">{body}</p> : null}
    {action ? <div className="pz-empty__action">{action}</div> : null}
  </div>
);

export default EmptyState;
